"use client";

import { useEffect, useState } from "react";
import { closeMobilemenu } from "@/utlis/toggleMobilemenu";
import Link from "next/link";
import Image from "next/image";

export default function Offcanvas({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkUser = () => {
      if (typeof window !== "undefined") {
        const stored = localStorage.getItem("user_token");
        if (stored) {
          setUser(JSON.parse(stored));
        } else {
          setUser(null);
        }
      }
    };

    checkUser();

    window.addEventListener("user_login", checkUser);
    window.addEventListener("user_logout", checkUser);

    return () => {
      window.removeEventListener("user_login", checkUser);
      window.removeEventListener("user_logout", checkUser);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user_token");
    setUser(null);
    window.dispatchEvent(new Event("user_logout"));
    window.location.href = "/"; // Redirect or refresh
    closeMobilemenu();
  };

  return (
    <>
      <div className="fix-area">
        <div className="offcanvas__info ">
          <div className="offcanvas__wrapper">
            <div className="offcanvas__content">
              <div className="offcanvas__top mb-5 d-flex justify-content-between align-items-center">
                <div className="offcanvas__logo">
                  <Link href="/">
                    <Image
                      src="/assets/img/logo.png"
                      width={230}
                      height={153}
                      alt="logo"
                    />
                  </Link>
                </div>
                <div
                  onClick={() => closeMobilemenu()}
                  className="offcanvas__close"
                >
                  <button>
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
              {/* <p className="text d-none d-xl-block">
                Nullam dignissim, ante scelerisque the is euismod fermentum odio
                sem semper the is erat, a feugiat leo urna eget eros. Duis
                Aenean a imperdiet risus.
              </p> */}
              <div className="mobile-menu fix mb-3 mean-container">
                <div className="mean-bar">
                  <a
                    href="#nav"
                    className="meanmenu-reveal"
                    style={{ right: 0, left: "auto", display: "inline" }}
                  >
                    <span>
                      <span>
                        <span />
                      </span>
                    </span>
                  </a>
                  <nav
                    className="mean-nav"
                    onClick={(e) => {
                      const link = e.target.closest("a");
                      if (!link) return;

                      const li = link.closest("li");
                      if (!li) return;

                      const submenu = li.querySelector("ul");

                      // 🔹 CASE 1: Parent menu with dropdown
                      if (submenu) {
                        e.preventDefault();

                        // close other dropdowns (optional but recommended)
                        li.parentElement
                          .querySelectorAll(":scope > li.dropdown-open")
                          .forEach((el) => {
                            if (el !== li) el.classList.remove("dropdown-open");
                          });

                        // toggle this dropdown
                        li.classList.toggle("dropdown-open");
                        return;
                      }

                      // 🔹 CASE 2: Submenu item → close offcanvas
                      closeMobilemenu();
                    }}
                  >
                    <ul style={{ display: "none" }}>{children}</ul>
                  </nav>
                </div>
              </div>
            </div>

            {user ? (
              <div className="offcanvas__contact mt-4 mb-4 d-flex flex-column gap-3">
                <button
                  onClick={handleLogout}
                  className="theme-btn w-100"
                  style={{ backgroundColor: "#333", borderColor: "#333" }}
                >
                  LOGOUT
                </button>
                <Link
                  href="/my-bookings"
                  onClick={() => closeMobilemenu()}
                  className="theme-btn w-100 text-center pulse-button"
                  style={{
                    backgroundColor: "#ff4d24",
                    borderColor: "#ff4d24",
                    color: "#fff"
                  }}
                >
                  MY BOOKINGS
                </Link>
              </div>
            ) : (
              <div className="offcanvas__contact mt-4 mb-4">
                <Link
                  href="/login"
                  onClick={() => closeMobilemenu()}
                  className="w-100 text-center !rounded-full transition-colors duration-300 hover:bg-white"
                  style={{
                    backgroundColor: "#ff4d24",
                    color: "#fff",
                    padding: "15px 30px",
                    fontWeight: "700",
                    display: "inline-block",
                    textTransform: "uppercase",
                    border: "2px solid #ff4d24"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "white";
                    e.currentTarget.style.color = "#ff4d24";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#ff4d24";
                    e.currentTarget.style.color = "#fff";
                  }}
                >
                  SIGN IN
                </Link>
              </div>
            )}

            {/* <div className="offcanvas__contact">
                <h4>Contact Info</h4>
                <ul>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon">
                      <i className="fal fa-map-marker-alt" />
                    </div>
                    <div className="offcanvas__contact-text">
                      <a target="_blank" href="#">
                        Main Street, Melbourne, Australia
                      </a>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                      <i className="fal fa-envelope" />
                    </div>
                    <div className="offcanvas__contact-text">
                      <a href="mailto:info@example.com">
                        <span className="mailto:info@example.com">
                          info@example.com
                        </span>
                      </a>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                      <i className="fal fa-clock" />
                    </div>
                    <div className="offcanvas__contact-text">
                      <a target="_blank" href="#">
                        Mod-friday, 09am -05pm
                      </a>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                      <i className="far fa-phone" />
                    </div>
                    <div className="offcanvas__contact-text">
                      <a href="tel:+11002345909">+11002345909</a>
                    </div>
                  </li>
                </ul>
                <div className="header-button mt-4">
                  <a href="contact.html" className="theme-btn text-center">
                    <span>
                      Get A Quote
                      <i className="fa-solid fa-arrow-right-long" />
                    </span>
                  </a>
                </div>
                <div className="social-icon d-flex align-items-center">
                  <a href="#">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a href="#">
                    <i className="fab fa-twitter" />
                  </a>
                  <a href="#">
                    <i className="fab fa-youtube" />
                  </a>
                  <a href="#">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div> */}
          </div>
        </div>
      </div>

      <div className="offcanvas__overlay " onClick={() => closeMobilemenu()} />
    </>
  );
}
